<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  bindBankcard,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/other/bankcard/edit',
      formComponents: ['baseForm'],
      editParams: {
        relSeq: this.$route.query.id || '',
      },
      params: {},
    };
  },
  computed: {
    detailParams () {
      return {
        // customerId: this.$route.query.id,
      };
    },
  },
  methods: {
    // detailApi: customerArchivesDetail,
    editApi: bindBankcard,
    handleParams (params) {
      this.params = params;
    },
    async handleSubSucc (res) {
      const data = this.params;
      if (data.ctrlType && data.ctrlType === 'edit') {
        // 修改状态
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.close();
      } else {
        // 绑卡状态
        if (data.isAddNewAccountBankRel !== undefined) {
          if (data.isAddNewAccountBankRel) {
            // 选择了新增并绑卡
            this.$message({
              type: 'success',
              message: '保存成功',
            });
            this.close();
          } else {
            // 选择了新增不绑卡，要提示绑卡
            const confirmRes = await this.$confirm('保存成功，是否继续绑卡？\n绑卡后借支、报销收款速度更快哦！', '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'success',
            }).catch(() => {
              this.close();
            });
            if (confirmRes === 'confirm') {
              // 页面切换成绑卡状态
              const _this = this.$refs.baseForm;
              this.setFormAttrVal({
                form: _this.baseForm,
                attr: 'hide',
                value: true,
                names: ['logonAndBindcard'],
              });
              this.setFormAttrVal({
                form: _this.baseForm,
                attr: 'hide',
                value: true,
                names: ['logonAndBindcard'],
              });
              _this.isAddNewAccountBankRel = false;
              this.$set(_this.baseForm.rules[_this.checkType][0], 'required', true);
            }
          }
        } else {
          // 普通绑卡
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        }
      }
    },
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
